<div class="page-header-container">
    <div class="page-title">
        {{'requests.clientData.newRequest.Title' | translate}}
    </div>
</div>

<div class="wizard-container" *ngIf="isDataLoaded">
    <button class="btn link-btn btn-back-txt" (click)="redirectFieldSelectionHandler()">
        <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
        <span>{{'requests.clientData.newRequest.Back' | translate}}</span>
    </button>

    <div class="row">
        <span class="col-12 d-flex justify-content-center title">
            {{(isPJ ? 'requests.clientData.newRequest.infoPJ.Title' : 'requests.clientData.newRequest.infoPF.Title') | translate}}
        </span>
    </div>

    <form #form="ngForm">
    <!--Company info-->
        <ng-container *ngIf="isPJ">
            <div class="row justify-content-around">
                <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-2">
                    <label class="text-field-label">{{'requests.clientData.newRequest.infoPJ.Name' | translate}}  
                        <span class="text-primary fw-bold">*</span>
                    </label>
                    <input kendoTextBox 
                        class="text-input"  
                        [(ngModel)]="clientDataRequestSaveModel.companyInformation.name" 
                        name="companyInformationName" 
                        required
                        #companyInformationName="ngModel"/>
                    <div class="error-info" *ngIf="companyInformationName.invalid  && (companyInformationName.dirty || form.submitted)">
                        <div  *ngIf="companyInformationName.errors?.['required']">
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-2">
                    <label class="text-field-label">{{'requests.clientData.newRequest.infoPJ.RegistrationCode' | translate}}</label>
                        <input           
                            kendoTextBox
                            class="text-input" 
                            [(ngModel)]="clientDataRequestSaveModel.companyInformation.registrationCode" 
                            name="companyInformationRegistrationCode"/>
                </div>
            </div>

            <div class="row justify-content-around">
                <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-2">
                    <label class="text-field-label">{{'requests.clientData.newRequest.infoPJ.LegalForm' | translate}}</label>
                        <input        
                            kendoTextBox
                            class="text-input" 
                            [(ngModel)]="clientDataRequestSaveModel.companyInformation.legalForm" 
                            name="companyInformationNLegalForm"/>
                </div>

                <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-2">
                    <label class="text-field-label">{{'requests.clientData.newRequest.infoPJ.mainField' | translate}}</label>
                    <input        
                        kendoTextBox
                        class="text-input" 
                        [(ngModel)]="clientDataRequestSaveModel.companyInformation.mainActivityField" 
                        name="companyInformationMainField"/>
                </div>
            </div>
        </ng-container>
        <!--/Company info-->

        <!--Personal info-->
        <div class="" *ngIf="!isPJ">
            <div class="row justify-content-around">
                <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-2">
                    <label class="text-field-label">{{'requests.clientData.newRequest.infoPF.nameFirst' | translate}} <span class="text-primary fw-bold">*</span></label> 
                    <input         
                        kendoTextBox
                        class="text-input" 
                        [(ngModel)]="clientDataRequestSaveModel.personalInformation.firstName" 
                        name="companyInformationFirstName" 
                        required
                        #personalInformationInformationFirstName="ngModel"/>
                    <div class="error-info" *ngIf="personalInformationInformationFirstName.invalid  && 
                        (personalInformationInformationFirstName.dirty || form.submitted)">
                        <div  *ngIf="personalInformationInformationFirstName.errors?.['required']">
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-2">
                    <label class="text-field-label">{{'requests.clientData.newRequest.infoPF.nameLast' | translate}} <span class="text-primary fw-bold">*</span></label>
                    <input         
                        kendoTextBox
                        class="text-input" 
                        [(ngModel)]="clientDataRequestSaveModel.personalInformation.lastName" 
                        name="companyInformationLastName" 
                        required
                        #personalInformationInformationLastName="ngModel"/>
                    <div class="error-info" *ngIf="personalInformationInformationLastName.invalid  && 
                        (personalInformationInformationLastName.dirty || form.submitted)">
                        <div  *ngIf="personalInformationInformationLastName.errors?.['required']">
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-around">
                <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-2">
                    <label class="text-field-label">{{'requests.clientData.newRequest.infoPF.IDseries' | translate}} <span class="text-primary fw-bold">*</span></label>
                    <input         
                        kendoTextBox
                        class="text-input" 
                        [(ngModel)]="clientDataRequestSaveModel.personalInformation.idSeries" 
                        name="personalInformationInformationIdSeries" 
                        required
                        #personalInformationInformationIdSeries="ngModel"/>
                    <div class="error-info" *ngIf="personalInformationInformationIdSeries.invalid  && 
                        (personalInformationInformationIdSeries.dirty || form.submitted)">
                        <div  *ngIf="personalInformationInformationIdSeries.errors?.['required']">
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>     
                </div>

                <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-2">
                    <label class="text-field-label">{{'requests.clientData.newRequest.infoPF.IDnumber' | translate}} <span class="text-primary fw-bold">*</span></label>
                    <input         
                        kendoTextBox
                        class="text-input" 
                        [(ngModel)]="clientDataRequestSaveModel.personalInformation.idNumber" 
                        name="personalInformationIdNumber" 
                        required
                        #personalInformationIdNumber="ngModel"/>
                    <div class="error-info" *ngIf="personalInformationIdNumber.invalid  && 
                        (personalInformationIdNumber.dirty || form.submitted)">
                        <div  *ngIf="personalInformationIdNumber.errors?.['required']">
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>     
                </div>
            </div>

            <div class="row justify-content-around">
                <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-2">
                    <label class="text-field-label">
                        {{'requests.clientData.newRequest.infoPF.IssuedBy' | translate}}
                        <span class="text-primary fw-bold">*</span>
                    </label>
                    <input        
                        kendoTextBox
                        class="text-input" 
                        [(ngModel)]="clientDataRequestSaveModel.personalInformation.issuedBy" 
                        name="personalInformationIssuedBy" 
                        required
                        #personalInformationIssuedBy="ngModel"/>
                    <div class="error-info" *ngIf="personalInformationIssuedBy.invalid  && 
                        (personalInformationIssuedBy.dirty || form.submitted)">
                        <div  *ngIf="personalInformationIssuedBy.errors?.['required']">
                            {{'common.validation.required' | translate}}
                        </div>
                    </div>    
                </div>
                <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3 mb-2">
                    <span 
                        class="text-field-label">{{'requests.clientData.newRequest.infoPF.ExpiryDate' | translate}} 
                        <span class="text-primary fw-bold">*</span>
                    </span>

                    <kendo-datepicker HJSuppress
                        class="date-frame" 
                        #expiryDate
                        [(ngModel)]="clientDataRequestSaveModel.personalInformation.expiryDate" 
                        required 
                        name="companyInformationExpiryDate"
                        class="custom-kendo-control-xl"
                        [fillMode]="fillModeOutline"
                        [rounded]="roundedLarge"
                        (click)="!expiryDate.isOpen ? expiryDate.toggle() : null"
                        #expiryDateModel="ngModel"
                        [popupSettings]="{popupClass : 'data-hj-suppress'}"
                    >
                        <kendo-datepicker-messages
                            today="{{ 'calendar.today' | translate }}"
                            toggle="{{ 'calendar.toggle' | translate }}"
                        >
                        </kendo-datepicker-messages>
                    </kendo-datepicker>
                    <div class="error-info" *ngIf="expiryDateModel.invalid  && 
                        (expiryDateModel.dirty || form.submitted)">
                        <div *ngIf="expiryDateModel.errors?.['required']">
                            {{'common.validation.required' | translate}}
                        </div>
                    </div> 
                </div>
            </div>
            <div class="d-flex justify-content-center mt-3">
                <div class="col-9">
                    <span class="text-field-label">{{'requests.clientData.newRequest.infoPF.CivilStatus' | translate}}</span>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <div class="radios col-9">
                    <div class="radio-option" *ngFor="let status of maritalStatuses">
                        <input class="radio-input cursor-pointer" type="radio" 
                            kendoRadioButton 
                            id="radio-{{status.code}}" 
                            name="radio-{{status.code}}"
                            [(ngModel)]="clientDataRequestSaveModel.personalInformation.dictionaryPersonMaritalStatusId" 
                            [value]="status.id" 
                            name="companyInformationMarital-{{status.code}}">
                        <label class="radio-label stats-text cursor-pointer" for="radio-{{status.code}}">{{status.value}}</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center">
            <div class="col-9">
                <client-data-request-uploader 
                    [clientDataRequest]="clientDataRequestSaveModel" 
                    [deleteFileHandler]="_filesHandler.deleteFileHandler"
                    [uploadFilesHandler]="_filesHandler.uploadFilesHandler">
                </client-data-request-uploader>
            </div>
        </div>
    <!-- Personal info -->
        <div class="d-flex justify-content-center mt-5">
            <button class="btn primary-btn px-5" 
                (click)="sendRequestCofirmationHandler()">
                <span>
                    {{ 'requests.clientData.newRequest.Next' | translate}}
                </span>
            </button>
        </div>
    </form> 
</div>
